import { memo, useMemo } from "react";
import { CollectionButton } from "../CollectionButton";
import { PriceColumn } from "../table/dashboard/columns/items/Price";
import { formatDisplay } from "../table/dashboard/columns/formatDisplay";
import Translations from "@translate/components/Watchlist/TokenItem";
import { I18nUtil } from "@utils";
import { TokenIcon } from "@components";

const I18n = I18nUtil.createScoped(Translations);

interface TokenItemProps {
  item: any;
  index: number;
  getVol24: (item: any) => any;
  callback?: () => void;
}

const TokenItem = memo(
  ({ item, index, getVol24, callback }: TokenItemProps) => {
    const marketCapDisplay = useMemo(
      () => formatDisplay([item?.market_cap], "$"),
      [item?.market_cap],
    );

    const vol24Display = useMemo(() => getVol24(item), [getVol24, item]);

    return (
      <CollectionButton
        defaultSelected={item.favorite}
        chainId={item.chain_id || ""}
        address={item.address || ""}
        className="flex flex-1 items-center gap-2 bg-background_white_overlay5 hover:bg-background_white_overlay10 cursor-pointer px-4 py-1 rounded-3 min-h-17 text-left"
        callback={callback}
      >
        <TokenIcon
          imageUrl={item.socials?.image_url}
          chainImageUrl={item.chain_image_url}
          className="w-10"
        />
        <div className="flex-1">
          <div className="body_medium_m text-content_primary flex">
            <span>{item.name}</span>
          </div>
          <div className="body_s text-content_tertiary md:break-normal break-all md:w-[354px] w-fit mt-[3px]">
            {item.symbol}
          </div>
        </div>
        <div className="flex-1 mx-3">
          <div className="body_s text-content_tertiary">{I18n.t("MC/Vol")}</div>
          <div className="body_s text-content_tertiary mt-1">
            <span className="body_medium_m text-content_primary">
              {marketCapDisplay.unit} {marketCapDisplay.data}
            </span>
            <span className="body_medium_m text-content_brand_primary ml-1">
              {vol24Display.unit || ""} {vol24Display.data}
            </span>
          </div>
        </div>
        <div className="flex-1 mx-3">
          <div className="body_s text-content_tertiary mb-1">
            {I18n.t("Price")}
          </div>
          <PriceColumn
            record={item}
            panelType="watchlist"
            index={index}
            sortBy="vol_5m"
          />
        </div>
      </CollectionButton>
    );
  },
);
TokenItem.displayName = "TokenItem";

export default TokenItem;
